export class StringUtil {
  static capitalize(words: string): string {
    return words.charAt(0).toUpperCase() + words.slice(1);
  }
}
